module.exports = __webpack_public_path__ + "img/tp-card-blank-mastercard.df0c80bf.png";